import React from "react";
import { Route, Routes } from "react-router-dom";
import AboutUsRoute from "routes/AboutUsRoute";
import ContactUsRoute from "routes/ContactUsRoute";
import HomeRoute from "routes/HomeRoute";
import InternalErrorRoute from "routes/InternalErrorRoute";
import NotFoundRoute from "routes/NotFoundRoute";
import OurWOrkRoute from "routes/OurWorkRoute";
import PrivacyPolicyRoute from "routes/PrivacyPolicyRoute";
import WiredropDownloadRoute from "routes/WiredropDownloadRoute";
import WiredropPrivacyPolicyRoute from "routes/WiredropPrivacyPolicyRoute";

import { withErrorBoundary } from "./layouts/RoutedErrorBoundary";

interface IRouteProps {
	path: string;
	element: any;
}

export enum Paths {
	aboutUs = "/about-us",
	contactUs = "/contact-us",
	error = "/error",
	notFound = "/not-found",
	root = "/",
	ourWork = "/what-we-do",
	privacyPolicy = "/privacy-policy/dropshot",
	wiredropPrivacyPolicy = "/privacy-policy/wiredrop",
	wiredropDownload = "/products/wiredrop"
}

const routes: IRouteProps[] = [
	{
		path: Paths.root,
		element: <HomeRoute />
	},
	{
		path: Paths.aboutUs,
		element: <AboutUsRoute />
	},
	{
		path: Paths.ourWork,
		element: <OurWOrkRoute />
	},
	{
		path: Paths.contactUs,
		element: <ContactUsRoute />
	},
	{
		path: Paths.notFound,
		element: <NotFoundRoute />
	},
	{
		path: Paths.error,
		element: <InternalErrorRoute />
	},
	{
		path: Paths.privacyPolicy,
		element: <PrivacyPolicyRoute />
	},
	{
		path: Paths.wiredropPrivacyPolicy,
		element: <WiredropPrivacyPolicyRoute />
	},
	{
		path: Paths.wiredropDownload,
		element: <WiredropDownloadRoute />
	}
];

const MainRouter = () => {
	return (
		<Routes>
			{routes.map((props: IRouteProps) => {
				const { path, element } = props;

				return <Route key={path} element={element} path={path} />;
			})}
			<Route element={<NotFoundRoute />} path="*" />
		</Routes>
	);
};

export default withErrorBoundary(MainRouter);
